import { render, staticRenderFns } from "./index.vue?vue&type=template&id=14cdde44&"
import script from "./index.vue?vue&type=script&lang=ts&"
export * from "./index.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jonas/Projects/Risolto/operator-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14cdde44')) {
      api.createRecord('14cdde44', component.options)
    } else {
      api.reload('14cdde44', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=14cdde44&", function () {
      api.rerender('14cdde44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/_messages/index.vue"
export default component.exports